import { DiagnosticsCard, DiagnosticsSection, StatusPill } from "./DiagnosticsPanelPrimitives";
import type { StatusTone } from "./DiagnosticsSettings.types";
import type { PreparedContractMatch, PreparedContractRow } from "./preparedContractDiff";

function matchTone(match: PreparedContractMatch): StatusTone {
  if (match === "match") return "ready";
  if (match === "miss") return "error";
  return "muted";
}

function matchLabel(match: PreparedContractMatch): string {
  if (match === "match") return "Match";
  if (match === "miss") return "Miss";
  return "Not published";
}

export function DiagnosticsPreparedContract({
  rows,
  probed,
}: {
  readonly rows: ReadonlyArray<PreparedContractRow>;
  readonly probed: boolean;
}) {
  if (!probed) return null;
  const unpublished = rows.every((row) => row.match === "unpublished");
  return (
    <DiagnosticsSection
      title="Prepared contract"
      id="diagnostics-prepared-contract"
      description={
        unpublished
          ? "Expected comes from CMMD. Until it publishes the field, every expected cell is not published."
          : "Expected comes from CMMD. Actual comes from the snapshot, Machine inventory, Provider Inventory, or Recheck."
      }
    >
      <DiagnosticsCard>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs">
            <thead>
              <tr className="border-b border-border/65 text-muted-foreground">
                <th className="px-4 py-2 font-medium">Name</th>
                <th className="px-4 py-2 font-medium">Expected</th>
                <th className="px-4 py-2 font-medium">Actual</th>
                <th className="px-4 py-2 font-medium">Authority</th>
                <th className="px-4 py-2 font-medium">Match</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.name} className="border-b border-border/45 last:border-b-0">
                  <td className="px-4 py-2 text-foreground">{row.name}</td>
                  <td className="px-4 py-2 text-muted-foreground">{row.expected}</td>
                  <td className="px-4 py-2 text-muted-foreground">{row.actual}</td>
                  <td className="px-4 py-2 text-muted-foreground">{row.authority}</td>
                  <td className="px-4 py-2">
                    <StatusPill label={matchLabel(row.match)} tone={matchTone(row.match)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </DiagnosticsCard>
    </DiagnosticsSection>
  );
}
